import $ from 'jquery'

/**
 * Initialisation
 */

export function init() {
  const $toggle = $('[data-toggle]')

  $toggle.on('click', function (event) {
    event.preventDefault()
    triggerToggle(this)
  })

  $toggle.on('keypress', function (event) {
    event.preventDefault()
    if (event.key === 'Enter') triggerToggle(this)
  })
}

const triggerToggle = (that) => {
  const $this = $(that)
  const id = $this.data('toggle')
  const $target = $('[data-toggle-target="' + id + '"]')

  $this.toggleClass('open')
  $target.toggleClass('open')
}
